


























import Vue from "vue";
import EhrIcon from "../opdrachten-module/EhrIcon.vue";
export default Vue.extend({
  name: "SectionCard",
  components: {
    EhrIcon
  },
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    smallerTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    cardIcon: {
      type: String,
      required: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasFooterContentSlot(): boolean {
      return !!this.$slots.footerContent;
    },
    hasExtraHeaderContentSlot(): boolean {
      return !!this.$slots.extraHeaderContent;
    },
  },
  data() {
    return {};
  },
});
